import { defineFormConfig } from "@src/components/business-form";
import type { StorePlacePlaceLotParams } from "../../../../../../api/storePlaces";

/** Значения формы размещения строки состава приходного ордера. */
export interface StockPlacementContentFormValues {
    /**
     * Код выбранной ячейки.
     *
     * `null` — пустое состояние picker-поля до выбора; с `nullable: true` и `required: true`
     * валидатор отличает «не выбрано» от кода `0`, который в OMP считается невалидным.
     */
    cellCode: number | null;
    /** Количество к размещению в ед. изм. строки. */
    placeQty: number;
}

/** Контекст формы размещения строки состава. */
export interface StockPlacementContentFormContext {
    /** Остаток к размещению по строке (`DepotQty` минус сумма `SpMovings.Qty`). */
    remainingQty: number;
}

/** Конфигурация формы размещения строки состава приходного ордера. */
export const stockPlacementContentFormConfig = defineFormConfig<
    StockPlacementContentFormValues,
    StorePlacePlaceLotParams,
    StockPlacementContentFormContext
>({
    fields: {
        cellCode: {
            type: "number",
            nullable: true,
            label: "Ячейка размещения",
            validation: { required: true },
            map: "cellCode",
        },
        placeQty: {
            type: "number",
            label: "Требуется разместить",
            validation: {
                required: true,
                positive: true,
                // max: (_values, ctx) => ctx.remainingQty, пока не нужно наверное, т.к вдруг надо будет больше реально разместить да
            },
            map: "qty",
        },
    },
});
